import { render, staticRenderFns } from "./CommissionAgreement.vue?vue&type=template&id=0a106449&"
import script from "./CommissionAgreement.vue?vue&type=script&lang=js&"
export * from "./CommissionAgreement.vue?vue&type=script&lang=js&"
import style0 from "./CommissionAgreement.vue?vue&type=style&index=0&id=0a106449&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports